import { BaseHead } from '@components/tables';
import {
    Grid,
    Stack,
    SxProps,
    TableCell,
    TableCellProps,
    TableRow,
    Theme,
    Typography,
    useThemeProps,
} from '@mui/material';
import color from '@theme/Colors';
import { omit } from 'lodash';
import { BiDownArrowAlt } from 'react-icons/bi';
import { HiOutlineArrowLongDown, HiOutlineArrowLongUp } from 'react-icons/hi2';

const CellOfRow = ({
    value,
    color,
    align,
    sx,
}: {
    value: JSX.Element | string | number;
    color?: string;
    align?: TableCellProps['align'];
    sx?: SxProps<Theme>;
}) => {
    return (
        <TableCell sx={{ ...sx, textAlign: align ?? 'center' }}>
            {['number', 'string'].includes(typeof value) ? (
                <Typography
                    variant="body1"
                    color={color ?? 'inherit'}
                    sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    {value}
                </Typography>
            ) : (
                value
            )}
        </TableCell>
    );
};

export type Sort = 'ASC' | 'DSC';

type BaseHeadProps = {
    title: string | React.ReactNode;
    sx?: SxProps<Theme>;
    background?: string;
    align?: TableCellProps['align'];
    sort?: Sort;
    onChangeSort?(sort: Sort): void;
};

const HeadOverview = (props: BaseHeadProps) => {
    const { title, sx, align, background, sort } = props;
    return (
        <>
            <TableRow>
                <TableCell sx={{ background: color.white }} colSpan={1} rowSpan={2} align="center">
                    <Typography fontSize={16} fontWeight={500}>
                        Verification Completed By User
                    </Typography>
                </TableCell>
                <TableCell sx={{ background: color.lightPrimary }} colSpan={3} align="center">
                    <Typography fontSize={16} fontWeight={500}>
                        Step 1
                    </Typography>
                </TableCell>
                <TableCell sx={{ background: color.lightPrimary }} colSpan={3} align="center">
                    <Typography fontSize={16} fontWeight={500}>
                        Step 2
                    </Typography>
                </TableCell>
            </TableRow>
            <TableRow>
                <BaseHead background="#fff" align="center" title="Total" />
                <BaseHead background="#fff" align="center" title="Approved" />
                <BaseHead background="#fff" align="center" title="Cancelled" />
                <BaseHead background="#fff" align="center" title="Total" />
                <BaseHead background="#fff" align="center" title="Approved" />
                <BaseHead background="#fff" align="center" title="Cancelled" />
            </TableRow>
        </>
    );
};
export { CellOfRow, HeadOverview };
